<template>
    <div>
        <PageTitle :title="footer.tipo == 2 ? $t('eventos.title') : (teatro.hash != 'UHmERrsRV19JCGQMg7Is' ? $t('header.partidos_temporada', {temporada: lista_abonados.nombre}) : $t('header.partidos_titulo', {titulo: lista_abonados.nombre}))"/>
        <FirstBanner/>

        <ListadoEventosClubs 
            v-if="footer.tipo == 1" 
            :eventos="events" 
            :loading="loadingEvents"
        />

        <template v-if="footer.tipo == 2">
            <div class="container mt-2">
                <SearchEvents
                    :placeholder="$t('teatros.buscar_placeholder')"
                    :teatro="teatro.hash_teatro"
                    @search-events="getEventos"
                />
            </div>

            <ListadoEventosImagen
                :eventos="events"
                :loading="loadingEvents"
                @recargar="getEventos(currentSearch)"
            />
        </template>

        <template v-if="events.length == 0 && !loadingEvents">
            <NoEvents/>
        </template>
    </div>
</template>

<script setup>
    import { useHead } from '@/composables/common/seo/useHead'
    import { useRouter } from '@/composables/common/router/useRouter'
    import { useEventoTracking } from '@/composables/front/analytics/useEventoTracking'
    import store from '@/store'
    import { config } from '@/config.js'
    import { computed, ref, onMounted } from 'vue'
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';
    import ListadoEventosClubs from '@/components/frontend/events/listado/ListadoEventosClubs';
    import NoEvents from '@/components/frontend/events/listado/NoEvents';
    import ListadoEventosImagen from '@/components/frontend/events/listado/ListadoEventosImagen';
    import SearchEvents from '@/components/frontend/events/SearchEvents'

    useHead('Eventos')

    const loadingEvents = ref(false);
    const currentSearch = ref('');
    const router = useRouter();
    const { trackViewItemList } = useEventoTracking({ store, getVuexAlias: config.getVuexAlias });

    /**
     * Map event list from API format to GA4 format
     * Transforms: { id, name, precio_minimo, ... } → { evento_id, evento_name, price, ... }
     */
    const mapEventsForTracking = (eventos = []) => {
        return eventos.map(evento => ({
            evento_id: evento.id,
            evento_name: evento.name,
            price: evento.precio_minimo || 0,
        }));
    };

    async function getEventos(search = '') {
        currentSearch.value = search;
        const params = {
            filters : {
                search: search
            }
        };

        loadingEvents.value = true;
        try {
            await store.dispatch('FRONT_EVENTS_INDEX', params);
            const eventosData = store.getters.getFrontEvents?.data || [];
            trackViewItemList(mapEventsForTracking(eventosData));
        } catch (error) {
            router.push({name: "front.error", params: {error: "getEventos"}});
            console.log(error);
        } finally {
            loadingEvents.value = false;
        }
    }

    onMounted(() => {
        if(store.getters.getFrontEvents === null) {
            getEventos();
        } else {
            const eventosData = store.getters.getFrontEvents?.data || [];
            trackViewItemList(mapEventsForTracking(eventosData));
        }

    });

    const teatro = computed(() => store.getters.getTeatro)
    const footer = computed(() => store.getters.getFooter)
    const lista_abonados = computed(() => store.getters.getListaAbonados)
    const events = computed(() => {
        return store.getters.getFrontEvents?.data ? store.getters.getFrontEvents.data : [] 
    })

</script>